<template>
    <div :class="[{ 'modal fade flex items-center p-2 md:p-0': true, show: showModal }]" id="quiz-share-validate-modal">
        <div @click="closeModal()" class="bg-backdrop absolute w-full h-full"></div>
        <div class="modal-content w-full h-full flex flex-col relative">
            <div class="modal-header flex justify-between items-center p-4 w-full fixed sticky">
                <h3 class="m-0 shadow-text-none">{{ $t('share_validate_header') }}</h3>
                <i @click="closeModal()" class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
            </div>
            <div class="modal-body p-4 z-10 overflow-y-auto">
                <p v-if="showRemoveDescription" class="text-red text-center font-bold">
                    {{ $t('share_validate_description_remove_from_school_library') }}
                </p>
                <p :class="`${showRemoveDescription ? 'mt-2' : ''}`">{{ $t('share_validate_description') }}</p>
                <!-- <XCheckbox
                    :checked="validateData.difficult"
                    :square="true"
                    :show-content="true"
                    :readonly="true"
                    :theme="validateData.difficult ? 'green' : 'grey'"
                    :disabled="validateData.difficult ? false : true"
                    size="lg"
                    id="select-level"
                    class="mt-4"
                >
                    {{ $t('share_validate_select_level') }}
                </XCheckbox>
                <XCheckbox
                    :checked="validateData.age"
                    :square="true"
                    :show-content="true"
                    :readonly="true"
                    :theme="validateData.age ? 'green' : 'grey'"
                    :disabled="validateData.age ? false : true"
                    size="lg"
                    id="select-age"
                    class="mt-2"
                >
                    {{ $t('share_validate_select_age') }}
                </XCheckbox> -->
                <XCheckbox
                    :checked="validateData.subject"
                    :square="true"
                    :show-content="true"
                    :readonly="true"
                    :theme="validateData.subject ? 'green' : 'grey'"
                    :disabled="validateData.subject ? false : true"
                    size="lg"
                    id="select-subject"
                    class="mt-2"
                >
                    {{ $t('share_validate_select_subject') }}
                </XCheckbox>
                <XCheckbox
                    :checked="validateData.grade"
                    :square="true"
                    :show-content="true"
                    :readonly="true"
                    :theme="validateData.grade ? 'green' : 'grey'"
                    :disabled="validateData.grade ? false : true"
                    size="lg"
                    id="select-grade"
                    class="mt-2"
                >
                    {{ $t('share_validate_select_grade') }}
                </XCheckbox>
                <XCheckbox
                    :checked="validateData.description"
                    :square="true"
                    :show-content="true"
                    :readonly="true"
                    :theme="validateData.description ? 'green' : 'grey'"
                    :disabled="validateData.description ? false : true"
                    size="lg"
                    id="select-write-description"
                    class="mt-2"
                >
                    {{ $t('share_validate_write_description') }}
                </XCheckbox>
                <XCheckbox
                    :checked="validateData.image"
                    :square="true"
                    :show-content="true"
                    :readonly="true"
                    :theme="validateData.image ? 'green' : 'grey'"
                    :disabled="validateData.image ? false : true"
                    size="lg"
                    id="select-image"
                    class="mt-2"
                >
                    {{ $t('share_validate_upload_image') }}
                </XCheckbox>
                <XCheckbox
                    :checked="validateData.numberOfQuestion"
                    :square="true"
                    :show-content="true"
                    :readonly="true"
                    :theme="validateData.numberOfQuestion ? 'green' : 'grey'"
                    :disabled="validateData.numberOfQuestion ? false : true"
                    size="lg"
                    id="select-active-questions"
                    class="mt-2"
                >
                    {{ $t('share_validate_number_questions', { minimum: minimumQuestionToShare }) }}
                </XCheckbox>
                <XCheckbox
                    :checked="validateData.activeQuestions"
                    :square="true"
                    :show-content="true"
                    :readonly="true"
                    :theme="validateData.activeQuestions ? 'green' : 'grey'"
                    :disabled="validateData.activeQuestions ? false : true"
                    size="lg"
                    id="select-active-questions"
                    class="mt-2"
                >
                    {{
                        $t('share_validate_active_questions', {
                            minimum: minimumQuestionToShare,
                            s: minimumQuestionToShare > 1 ? 's' : ''
                        })
                    }}
                </XCheckbox>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import XCheckbox from '@/components/v2/XCheckbox'

export default {
    components: {
        XCheckbox
    },

    props: {
        validateData: {
            type: Object
        },

        showRemoveDescription: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showModal: true
        }
    },

    computed: {
        ...mapState({
            minimumQuestionToShare: state => state.minimumQuestionToShare
        })
    },

    methods: {
        closeModal() {
            this.showModal = false

            setTimeout(() => {
                this.$emit('close')
            }, 300)
        }
    }
}
</script>

<style lang="scss">
#quiz-share-validate-modal {
    &.show {
        background-color: rgba(0, 0, 0, 0.5);
        .modal-content {
            opacity: 1;
            transform: translateY(0px);
        }
    }

    .modal-content {
        max-width: 440px;
        width: auto !important;
        height: auto !important;
    }
}
</style>